export default "__VITE_ASSET__mqCNrN1f__"